import { render, staticRenderFns } from "./GovIntroductions.vue?vue&type=template&id=a84532d6&scoped=true"
import script from "./GovIntroductions.vue?vue&type=script&lang=js"
export * from "./GovIntroductions.vue?vue&type=script&lang=js"
import style0 from "./GovIntroductions.vue?vue&type=style&index=0&id=a84532d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84532d6",
  null
  
)

export default component.exports